export default "__VITE_ASSET__CqD6Ba6V__"